import { ref, watch, computed, } from '@vue/composition-api'
import store from '@/store'


export default function useAppElementList(props={
  // default options
  fetchDataUrl:"",
  deleteDataUrl: "",
  tableColumns: [],
  storeModuleName: "",

  // itemView options
  tableView: true,
  gridView: true,
  extraViews: [],

  perPage: 10,
  perPageOptions: [10, 25, 50],

  useDefaultActions: ["edit", "delete"],

  idKey: "uuid"

}) {
  const idKey = ref(props.idKey)

  const useDefaultActions = ref([...props.useDefaultActions])

  const defaultActions = [
      {
        key: "edit",
        label: 'edit',
        action: (item) => {
          if (props.storeModuleName) {
            store.commit(`${props.storeModuleName}/SET_ELEMENT_IN_EDIT`, JSON.parse(JSON.stringify(item)))
            store.commit(`${props.storeModuleName}/SET_IS_ADD_NEW_ELEMENT_COLLAPSED`, true)
          }
        }
      },
      {
        key: "delete",
        label: 'удалить',
        action: (item) =>{
          dataLoading.value = true
          deleteData({id: item[idKey.value]}, refetchData)
        }
      }
  ]

  const overallActions = () => {
    const actions = {
      key: "actions",
      label: 'действия',
      actions: [
          ...props.tableColumns.filter(el => el.key === "actions").map(el => el.actions).flat(),
          ...defaultActions.filter(el => useDefaultActions.value.includes(el.key)),
      ]
    }

    return actions.actions.length > 0 ? actions : {}
  }



  const tableColumns = ref([
      ...props.tableColumns.filter((el)=> el.key !== "actions"),
      overallActions()
  ])

  const dataLoading = ref(false)
  const fetchedData = ref([])
  const totalElements = ref(0)
  const currentPage = ref(1)

  const perPage = ref(props.perPage)
  const perPageOptions = ref([...props.perPageOptions])

  const searchQuery = ref('')
  const sortBy = ref(idKey.value)
  const isSortDirDesc = ref(true)
  const extraFilters = ref({})


  const itemView = ref(
      props.tableView ? 'table-view': props.gridView ? 'grid-view': ''
  )


  const itemViewOptions = [
      {icon: 'ListIcon', value: 'table-view', available: props.tableView},
      {icon: 'GridIcon', value: 'grid-view', available: props.gridView},
      ...props.extraViews
  ]

  const dataMeta = computed(() => {
    const localItemsCount = fetchedData.value ? fetchedData.value.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalElements.value,
    }
  })

  const refetchData = () => {
    dataLoading.value = true
    fetchData((data)=>{
      fetchedData.value = data.results
      totalElements.value = data.count
      dataLoading.value = false;

      if (props.storeModuleName) {
        store.commit(`${props.storeModuleName}/UPDATE_REFETCH_DATA`, false)
      }
    })

  }

  watch([currentPage, perPage, extraFilters, searchQuery], () => {
    refetchData()
  },{ deep: true } )


  watch(() => {
    return props.storeModuleName ? store.state[props.storeModuleName].refetchData : false
   }, (val)=> {
      val === true ? refetchData() : false
   });


  const fetchData = (on_success=null, on_err=null, on_final=null) => {
    store
        .dispatch(props.fetchDataUrl, {
          params: {
            search: searchQuery.value,
            size: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            ...extraFilters.value
          }
      })
        .then((response) => on_success ? on_success(response.data) : null)
        .catch((err) => on_err ? on_err(err) : null)
        .finally((response) => on_final ? on_final(response) : null)
  }

  const deleteData = (ctx, on_success=null, on_err=null, on_final=null) => {
    store
        .dispatch(props.deleteDataUrl, ctx.id)
        .then((response) => on_success ? on_success(response.data) : null)
        .catch((err) => on_err ? on_err(err) : null)
        .finally((response) => on_final ? on_final(response) : null)
  }

  const selected = ref([])

  return {

    tableColumns,

    fetchData,
    refetchData,

    fetchedData,
    dataLoading,
    perPage,
    currentPage,
    totalElements,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    extraFilters,

    // UI
    itemView,
    itemViewOptions,

    selected,

  }
}
